import { request } from './client'
import type {
  AddItemsRequest,
  BatchAssignRequest,
  BatchResult,
  Pallet,
  RecentPallet,
  RemoveItemsRequest,
} from './contracts'

export function getRecentPallets(signal?: AbortSignal): Promise<RecentPallet[]> {
  return request<RecentPallet[]>('/pallets/recent', { signal })
}

export function getPallet(palletCode: string, signal?: AbortSignal): Promise<Pallet> {
  return request<Pallet>(`/pallets/${encodeURIComponent(palletCode)}`, { signal })
}

export function addItems(
  palletCode: string,
  body: AddItemsRequest,
  signal?: AbortSignal,
): Promise<BatchResult> {
  return request<BatchResult>(`/pallets/${encodeURIComponent(palletCode)}/items`, {
    method: 'POST',
    body,
    signal,
  })
}

/** DELETE with a body, per the spec. */
export function removeItems(
  palletCode: string,
  body: RemoveItemsRequest,
  signal?: AbortSignal,
): Promise<BatchResult> {
  return request<BatchResult>(`/pallets/${encodeURIComponent(palletCode)}/items`, {
    method: 'DELETE',
    body,
    signal,
  })
}

export function batchAssign(body: BatchAssignRequest, signal?: AbortSignal): Promise<BatchResult> {
  return request<BatchResult>('/pallets/batch-assign', { method: 'POST', body, signal })
}
